/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryProjectResponse } from './RevisdomAPIViewModelsEntryProjectResponse';
import {
    RevisdomAPIViewModelsEntryProjectResponseFromJSON,
    RevisdomAPIViewModelsEntryProjectResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryProjectResponseToJSON,
    RevisdomAPIViewModelsEntryProjectResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryProjectResponse';

/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryProjectListResponse
 */
export interface RevisdomAPIViewModelsEntryProjectListResponse {
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsEntryProjectResponse>}
     * @memberof RevisdomAPIViewModelsEntryProjectListResponse
     */
    items?: Array<RevisdomAPIViewModelsEntryProjectResponse> | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryProjectListResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryProjectListResponse(value: object): value is RevisdomAPIViewModelsEntryProjectListResponse {
    return true;
}

export function RevisdomAPIViewModelsEntryProjectListResponseFromJSON(json: any): RevisdomAPIViewModelsEntryProjectListResponse {
    return RevisdomAPIViewModelsEntryProjectListResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryProjectListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryProjectListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(RevisdomAPIViewModelsEntryProjectResponseFromJSON)),
    };
}

export function RevisdomAPIViewModelsEntryProjectListResponseToJSON(json: any): RevisdomAPIViewModelsEntryProjectListResponse {
    return RevisdomAPIViewModelsEntryProjectListResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryProjectListResponseToJSONTyped(value?: RevisdomAPIViewModelsEntryProjectListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(RevisdomAPIViewModelsEntryProjectResponseToJSON)),
    };
}

